import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import {
  getGiftCardAmount,
  isNeedAnotherPaymentMethod
} from '@/modules/cart/infrastructure/CartReduxRepository/GiftCardThunks';

import {
  setIsGiftCardIncompatibleProductsAllModalOpen,
  setIsGiftCardIncompatibleProductsModalOpen,
  setIsGiftCardInsufficientModalOpen
} from '../store/slices/billing';

import { getProductsNotCompatibleWithGiftCard } from './use-gift-card-data';

const useCheckGiftCardModals = () => {
  const dispatch = useAppDispatch();
  const { data: cart } = useAppSelector((state) => state.cart);
  useEffect(() => {
    if (!cart) return;
    const needAnotherPaymentMethod = isNeedAnotherPaymentMethod(cart);
    const amount = getGiftCardAmount(cart);
    const productsNotCompatible = getProductsNotCompatibleWithGiftCard(cart);
    const producstFromCart = cart?.lineItems?.length;

    if (amount === 0 && productsNotCompatible.length > 0) {
      if (producstFromCart === productsNotCompatible.length) {
        dispatch(setIsGiftCardIncompatibleProductsAllModalOpen(true));
        return;
      }
      dispatch(setIsGiftCardIncompatibleProductsModalOpen(true));
      return;
    }

    if (needAnotherPaymentMethod) {
      dispatch(setIsGiftCardInsufficientModalOpen(true));
      return;
    }
  }, [dispatch, cart]);
};

export default useCheckGiftCardModals;
